import { css } from '@emotion/css';

import { AI_COLORS } from '../../consts';

export const aiMenuIconFill = css`
  fill: ${AI_COLORS.royalBlue};
`;
